module.exports = __webpack_public_path__ + "img/EIDSA_Clinical_Logo.ab6ff3c1.png";